import { useDialog } from '@globals/dialog/useDialogStore'
import { TenantMemberAndTeamDisplayData } from '@kudos/http-client'
import { Selectable } from '@shared/filters/selections'
import { v4 as uuidv4 } from 'uuid'
export enum RecognitionModalViews {
  SendRecognition,
  DraftAndInProgressRecognitions,
}

export type RecognitionDialogData = {
  view: RecognitionModalViews
  recognitionId?: string
  recipients?: TenantMemberAndTeamDisplayData[]
  qualities?: Selectable[]
  refinementSessionId?: string
}

export const RECOGNITION_MODAL_KEY = 'recognitionModalKey'

const useRecognitionModal = () => {
  const {
    setData,
    openDialog: open,
    closeDialog: close,
    isOpen,
    dialogData,
  } = useDialog<RecognitionDialogData>(RECOGNITION_MODAL_KEY)

  return {
    setView: (data: RecognitionDialogData) => {
      setData({
        ...data,
        refinementSessionId: dialogData?.refinementSessionId,
      })
    },
    openDialog: (data: RecognitionDialogData) => {
      open({
        ...data,
        refinementSessionId: uuidv4(),
      })
    },
    closeDialog: () => {
      close()
    },
    isOpen,
    dialogData,
  }
}

export default useRecognitionModal
